import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { modelGetByDocId } from '../../../../actions/capa';


// Import CSS & assets
import ico_ia_stars from '../../../../assets/ico/ico_ia_3_stars.svg';
import ico_check from '../../../../assets/ico/ico_check.svg';

// import * as AI_helpers from '../../../../helpers/AI_helpers';


var modelePLU = null;
var zoneUrba_id = [];
var zoneUrba2_id = [];
var zoneCity_id = [];

var addNewRuleset = false;

var ruleset_current = null;
var ruleset_memory = null;

var nbRules_total = 0;
var nbRulesets_total = 0;
var nb_docs_lit = 0;
var nb_docs_graph = 0;

var autoValidate = false;

const AIpluFake = ({ capacity, setCapacity, setRuleUpdateTracker, setIsAIRunning }) => {

    const dispatch = useDispatch();

    const [AItitle, setAItitle] = useState("Lancer notre IA pour analyser le PLU");
    const [nbDocs, setNbDocs] = useState(0);
    const [isDisclaimer, setIsDisclaimer] = useState(false);
    const [isAskingRules, setIsAskingRules] = useState(false);
    const [isAddingNewRules, setIsAddingNewRules] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [isEnding, setIsEnding] = useState(false);
    const [isError, setIsError] = useState(false);
    const [AIstep, setAIstep] = useState(0);
    const [step1_status, setStep1_status] = useState("none");
    const [step1_description, setStep1_description] = useState("");
    const [step2_status, setStep2_status] = useState("none");
    const [step2_description, setStep2_description] = useState("");
    const [step3_status, setStep3_status] = useState("none");
    const [step3_description, setStep3_description] = useState("");
    const [step4_status, setStep4_status] = useState("none");
    const [step4_description, setStep4_description] = useState("");
    const [step5_status, setStep5_status] = useState("none");
    const [step5_description, setStep5_description] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    // ACTIONS
    const handleRunClick = () => {
        setAItitle("Disclaimer");
        setIsDisclaimer(true);
    }
    const handleDisclaimerClick = () => {
        setIsDisclaimer(false);
        ruleset_current = JSON.parse(JSON.stringify(capacity?.rules?.ruleset));
        ruleset_memory = JSON.parse(JSON.stringify(capacity?.rules?.ruleset));
        if (isExistingRules()) {
            setTimeout(() => {
                setAItitle("Avant de commencer");
                setIsAskingRules(true);
            }, 400)
        }
        else {
            addNewRuleset = false;
            setIsAddingNewRules(false);
            startRunning();
        }
    }
    const handleRulesKeepClick = () => {
        addNewRuleset = true;
        setIsAddingNewRules(true);
        setIsAskingRules(false);
        startRunning();
    }
    const handleRulesResetClick = () => {
        addNewRuleset = false;
        setIsAddingNewRules(false);
        rulesetReset(true);
    }

    const startRunning = () => {
        setAItitle("Analyse IA en cours...");
        setIsRunning(true);
        setIsAIRunning(true);
        scroll_to_rules();
        setTimeout(() => {
            startRunning_step1();
        }, 600)
    }
    // STEP 1 : Get main document
    const startRunning_step1 = () => {
        setAIstep(1);
        setStep1_status("loading");
        setTimeout(() => {
            setStep1_status("done");
            nb_docs_lit = 0;
            nb_docs_graph = 0;
            try {
                nb_docs_lit = capacity?.rules?.gpu_data?.files?.Règlements["Règlements écrits"].length;
                nb_docs_graph = capacity?.rules?.gpu_data?.files?.Règlements["Règlements graphiques"].length;
            } catch (error) {
            }
            setNbDocs(nb_docs_lit + nb_docs_graph);
            setStep1_description("Documents identifiés : " + (nb_docs_lit > 1 ? (nb_docs_lit + " règlements écrits") : nb_docs_lit === 1 ? "1 règlement écrit" : "") + (nb_docs_graph > 1 ? (" et " + nb_docs_graph + " règlements graphiques") : nb_docs_graph === 1 ? " et 1 règlement graphique" : ""));
            setTimeout(() => {
                startRunning_step2();
            }, 340)
        }, 1000)
    }
    // STEP 2 : Analyze structure (fetch modelePLU)
    const startRunning_step2 = () => {
        setAIstep(2);
        setStep2_status("loading");
        setTimeout(() => {
            fetchGPU_modele();
        }, 1500)
    }
    const keepRunning_step2 = () => {
        setStep2_status("done");
        setStep2_description(modelePLU?.rules?.gpu_data?.zoneUrba_all.length + " sections identifiées");
        setTimeout(() => {
            startRunning_step3();
        }, 340)
    }
    // STEP 3 : Get common rules
    const startRunning_step3 = () => {
        setAIstep(3);
        setStep3_status("loading");
        setTimeout(() => {
            keepRunning_step3();
        }, 2000)
    }
    const keepRunning_step3 = () => {
        var nb_rules = 0;
        var rulesets = [];
        // Search rules
        if (modelePLU?.rules?.ruleset) {
            modelePLU.rules.ruleset.forEach(ruleset => {
                // Check common ruleset
                if (!(ruleset?.zonesUrba) || ruleset.zonesUrba.length === 0) {
                    rulesets.push(ruleset);
                    ruleset.items.forEach(item => {
                        if (item?.type === "rule") {
                            nb_rules++;
                        }
                    });
                }
                // Check city ruleset
                for (var i = 0; i < zoneCity_id.length; i++) {
                    if (ruleset?.zonesUrba && ruleset.zonesUrba.includes(zoneCity_id[i])) {
                        rulesets.push(ruleset);
                        ruleset.items.forEach(item => {
                            if (item?.type === "rule") {
                                nb_rules++;
                            }
                        });
                        break;
                    }
                }
            });
        }
        if (nb_rules > 0 && rulesets.length > 0) {
            setStep3_status("done");
            setStep3_description(rulesets.length + (rulesets.length > 1 ? " ensembles" : " ensemble") + " de règles et " + nb_rules + (nb_rules > 1 ? " règles" : " règle") + " créés");
            console.log("Adding ruleset", addNewRuleset);
            if (addNewRuleset === true) {
                rulesetAdd(rulesets, true, true);
            }
            else {
                rulesetResetAdd(rulesets, true, true);
            }
            nbRules_total = nbRules_total + nb_rules;
            nbRulesets_total = nbRulesets_total + rulesets.length;
        }
        else {
            setStep3_status("done");
            setStep3_description("Aucune règle identifiée");
        }
        setTimeout(() => {
            startRunning_step4();
        }, 340)
    }
    // STEP 4 : Get specific rules zoneUrba
    const startRunning_step4 = () => {
        setAIstep(4);
        setStep4_status("loading");
        setTimeout(() => {
            keepRunning_step4();
        }, 2000)
    }
    const keepRunning_step4 = () => {
        var nb_rules = 0;
        var rulesets = [];
        // Search rules
        if (modelePLU?.rules?.ruleset) {
            modelePLU.rules.ruleset.forEach(ruleset => {
                var ruleset_test = false;
                for (var i = 0; i < zoneUrba_id.length; i++) {
                    if (ruleset?.zonesUrba && ruleset.zonesUrba.includes(zoneUrba_id[i])) {
                        ruleset_test = true;
                        break;
                    }
                }
                if (ruleset_test) {
                    rulesets.push(ruleset);
                    ruleset.items.forEach(item => {
                        if (item?.type === "rule") {
                            nb_rules++;
                        }
                    });
                }
            });
        }
        if (nb_rules > 0 && rulesets.length > 0) {
            setStep4_status("done");
            setStep4_description(rulesets.length + (rulesets.length > 1 ? " ensembles" : " ensemble") + " de règles et " + nb_rules + (nb_rules > 1 ? " règles" : " règle") + " créés");
            console.log("Adding ruleset", addNewRuleset);
            rulesetAdd(rulesets, true, true);
            nbRules_total = nbRules_total + nb_rules;
            nbRulesets_total = nbRulesets_total + rulesets.length;
        }
        else {
            setStep4_status("done");
            setStep4_description("Aucune règle identifiée");
        }
        setTimeout(() => {
            startRunning_step5();
        }, 340)
    }
    // STEP 5 : Get specific rules zoneUrba2
    const startRunning_step5 = () => {
        setAIstep(4);
        setStep5_status("loading");
        setTimeout(() => {
            keepRunning_step5();
        }, 2000)
    }
    const keepRunning_step5 = () => {
        var nb_rules = 0;
        var rulesets = [];
        // Search rules
        if (modelePLU?.rules?.ruleset) {
            modelePLU.rules.ruleset.forEach(ruleset => {
                var ruleset_test = false;
                // Check zoneUrba2
                for (var i = 0; i < zoneUrba2_id.length; i++) {
                    if (ruleset?.zonesUrba && ruleset.zonesUrba.includes(zoneUrba2_id[i])) {
                        ruleset_test = true;
                        break;
                    }
                }
                // // Check zoneCity
                // if (ruleset_test === false) {
                //     for (var i = 0; i < zoneCity_id.length; i++) {
                //         if (ruleset?.zonesUrba && ruleset.zonesUrba.includes(zoneCity_id[i])) {
                //             ruleset_test = true;
                //             break;
                //         }
                //     }
                // }
                // If test true
                if (ruleset_test) {
                    rulesets.push(ruleset);
                    ruleset.items.forEach(item => {
                        if (item?.type === "rule") {
                            nb_rules++;
                        }
                    });
                }
            });
        }
        if (nb_rules > 0 && rulesets.length > 0) {
            setStep5_status("done");
            setStep5_description(rulesets.length + (rulesets.length > 1 ? " ensembles" : " ensemble") + " de règles et " + nb_rules + (nb_rules > 1 ? " règles" : " règle") + " créés");
            console.log("Adding ruleset", addNewRuleset);
            rulesetAdd(rulesets, true, true);
            nbRules_total = nbRules_total + nb_rules;
            nbRulesets_total = nbRulesets_total + rulesets.length;
        }
        else {
            setStep5_status("done");
            setStep5_description("Aucune règle identifiée");
        }
        setTimeout(() => {
            setAIstep(0);
            setTimeout(() => {
                capaSave();
                setAItitle("Analyse IA terminée");
                setIsEnding(true);
                setIsRunning(false);
                setIsAIRunning(false);
                autoValidate = true;
                setTimeout(() => {
                    console.log("AUTO VALIDATE", autoValidate);
                    if (autoValidate) {
                        stopRunning();
                    }
                }, 20000)
            }, 400)
        }, 2000)
    }

    const handleEndValidateClick = () => {
        stopRunning();
    }
    const handleEndResetClick = () => {
        autoValidate = false;
        rulesetResetAdd(ruleset_memory, false, true);
        setTimeout(() => {
            stopRunning();
            setTimeout(() => {
                capaSave();
            }, 3000)
        }, 300)
    }

    const stopRunning = () => {
        setAItitle("Lancer notre IA pour analyser le PLU");
        setNbDocs(0);
        setIsRunning(false);
        setIsAIRunning(false);
        setIsEnding(false);
        setIsError(false);
        setErrorMessage("");
        setIsDisclaimer(false);
        setIsAskingRules(false);
        setIsAddingNewRules(false);

        setAIstep(0);
        setStep1_status("none");
        setStep1_description("");
        setStep2_status("none");
        setStep2_description("");
        setStep3_status("none");
        setStep3_description("");
        setStep4_status("none");
        setStep4_description("");
        setStep5_status("none");
        setStep5_description("");

        modelePLU = null;
        zoneUrba_id = [];
        zoneUrba2_id = [];
        zoneCity_id = [];
        addNewRuleset = false;
        ruleset_current = null;
        ruleset_memory = null;
        nbRules_total = 0;
        nbRulesets_total = 0;
        autoValidate = false;
    }

    // FETCH & FUNCTIONS
    const fetchGPU_modele = () => {
        console.log("FETCHING GPU MODELE", capacity?.rules?.gpu_data?.document?.id);
        dispatch(modelGetByDocId(capacity?.rules?.gpu_data?.document?.id, { test: "ok" }, handleGPUModeleGetSuccess, handleGPUModeleGetFail));
    }
    const handleGPUModeleGetSuccess = (data) => {
        console.log("-FETCHING GPU MODELE- : Success", data);
        if (data.length > 0) {
            modelePLU = data[0];
            // Get zoneUrba
            var zoneUrba_search = [];
            capacity?.rules?.gpu_data?.zoneUrba.forEach(zu => {
                zoneUrba_search.push(zu?.properties?.libelle);
            })
            zoneUrba_id = [];
            for (var i = 0; i < modelePLU?.rules?.gpu_data?.zoneUrba_all.length; i++) {
                for (var j = 0; j < zoneUrba_search.length; j++) {
                    if (modelePLU?.rules?.gpu_data?.zoneUrba_all[i]?.properties?.libelle === zoneUrba_search[j]) {
                        zoneUrba_id.push(modelePLU?.rules?.gpu_data?.zoneUrba_all[i]?.properties?.id);
                        break;
                    }
                }
            }
            console.log("zoneUrba_id", zoneUrba_id);
            // Get zoneUrba2 ids
            zoneUrba2_id = [];
            capacity?.rules?.gpu_data?.zoneUrba2.forEach(zu => {
                zoneUrba2_id.push(zu?.properties?.id);
            })
            console.log("zoneUrba2_id", zoneUrba2_id);
            // Get zoneCity
            zoneCity_id = [];
            if (modelePLU?.rules?.gpu_data?.zoneCity_all) {
                modelePLU.rules.gpu_data.zoneCity_all.forEach(zoneCity_i => {
                    if (zoneCity_i?.properties?.inseecode) {
                        zoneCity_i.properties.inseecode.forEach(inseecode_i => {
                            if (inseecode_i === capacity?.city?.inseecode) {
                                zoneCity_id.push(zoneCity_i?.properties?.id);
                            }
                        })
                    }
                })
            }
            console.log("zoneCity_id", zoneCity_id);
            // Continue process
            keepRunning_step2();
        }
        else {
            // ERROR HANDLING
            handleError("Le PLU n'a pas encore été analysé par notre serveur IA.");
        }
    };
    const handleGPUModeleGetFail = (error) => {
        console.log("-FETCHING GPU MODELE- : Error", error.response.data);
        // ERROR HANDLING
        handleError("Impossible de contacter le serveur.");
    }
    const handleError = (error_message) => {
        // Stop process
        setIsRunning(false);
        setAIstep(0);
        // Set error
        setAItitle("Erreur");
        setIsError(true);
        setErrorMessage(error_message);
        // Restore old rules
        rulesetResetAdd(ruleset_memory, false, true);

        setTimeout(() => {
            // Reset capa data
            capaSave();
            setTimeout(() => {
                stopRunning();
            }, 7000)
        }, 1000)
    }

    // UI MANIPULATIONS
    const scroll_to_rules = () => {
        var target_id = "section_5_rules";
        var delta = 0;
        var section_id = target_id.substring(0, 9);
        var section_dom = document.getElementById(section_id);
        var target_dom = document.getElementById(target_id);
        if (section_dom && target_dom) {
            var section_top = section_dom.offsetTop;
            var target_top = target_dom.offsetTop;
            document.getElementById("section_data").scrollTop = section_top + target_top + delta + 10;
        }
    }

    // RULES MANIPULATIONS
    const isExistingRules = () => {
        if (capacity?.rules?.ruleset && (capacity?.rules?.ruleset.length > 1 || capacity?.rules?.ruleset[0]?.items.length > 0)) {
            return true
        }
        else { return false }
    }
    const rulesetReset = (toSave) => {
        console.log("-AI RULESET- : Reset");
        var new_rules = { ...capacity.rules };
        ruleset_current = [
            {
                id: "ruleGroup_0",
                name: "Règlement",
                items: [],
                numerotation: "0.",
                isFromAI: false
            }
        ]
        new_rules.ruleset = JSON.parse(JSON.stringify(ruleset_current));
        if (toSave) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Mise à jour des règles avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
            setRuleUpdateTracker("-" + (Date.now()).toString());
        }
        else {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Suppression de règlements avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
        }
        // Update UI of ruleset title
        var dom_title = document.getElementById("ruleGroup_0_title");
        if (dom_title) {
            dom_title.value = "Règlement";
        }
        setIsAskingRules(false);
        startRunning();
    }
    const rulesetResetAdd = (rulesetList, fromAI, toSave) => {
        console.log("-AI RULESET- : Reset and Add", rulesetList);
        var new_rules = { ...capacity.rules };
        ruleset_current = [];
        var ruleset0_title = "Règlement";
        rulesetList.forEach(rulesetNew => {
            ruleset_current.push({ ...rulesetNew, isFromAI: fromAI, lastUpdate2: (rulesetNew?.id || "ruleGroup_x") + "-" + (Date.now()).toString() });
            if (rulesetNew?.id === "ruleGroup_0") { ruleset0_title = rulesetNew?.name || "Règlement" }
        });
        var ruleset_current_raw = ruleset_current.slice(0);
        new_rules.ruleset = JSON.parse(JSON.stringify(ruleset_current_raw));
        if (toSave) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Mise à jour des règles avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
            setRuleUpdateTracker("-" + (Date.now()).toString());
        }
        else {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Ajout de règlements avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
        }
        // Update UI of ruleset title
        var dom_title = document.getElementById("ruleGroup_0_title");
        if (dom_title) {
            dom_title.value = ruleset0_title;
        }
    }
    const rulesetAdd = (rulesetList, fromAI, toSave) => {
        console.log("-AI RULESET- : Add", rulesetList);
        var new_rules = { ...capacity.rules };
        rulesetList.forEach(rulesetNew => {
            ruleset_current.push({ ...rulesetNew, isFromAI: fromAI, id: (rulesetNew?.id === "ruleGroup_0" ? "ruleGroup_00" : rulesetNew?.id) })
        });
        new_rules.ruleset = JSON.parse(JSON.stringify(ruleset_current));
        if (toSave) {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Mise à jour des règles avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
            setRuleUpdateTracker("-" + (Date.now()).toString());
        }
        else {
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("rules");
            toSaveData.autoSave = false;
            toSaveData.action = "Ajout de règlements avec";
            toSaveData.value = "l'outil d'analyse IA";
            setCapacity({ ...capacity, rules: new_rules, toSave: toSaveData });
        }
    }
    const capaSave = () => {
        console.log("AI SAVING CAPA", capacity);
        setRuleUpdateTracker((Date.now()).toString());
    }


    return (
        <div className="">
            <div className="app__sectiondata_widget_spacer_10"></div>
            <div className="app__ai_container_main">
                {/* <div className={`app__ai_container_shadow ${isRunning ? "app__ai_container_shadow_running" : ""}`}></div> */}
                <div className={`app__sectiondata__widget app__ai_container ${isRunning ? "app__ai_container_glowing" : ""}`}>
                    {/* LANCH BUTTON */}
                    {/* <div className={`app__ai_start_button ${isRunning ? "app__ai_start_button_running app__ai_start_button_hidden" : ""}`} onClick={() => { handleRunClick() }}> */}
                    <div className={`app__ai_start_button ${(isDisclaimer || isAskingRules || isRunning || isEnding) ? "app__ai_start_button_running2" : ""}`} onClick={() => { handleRunClick() }}>
                        <img src={ico_ia_stars} />
                        {AItitle}
                        {/* {isDisclaimer ? "Disclaimer" :
                            isAskingRules ? "Avant de commencer" :
                                isRunning ? "Analyse IA en cours..."
                                    : "Lancer notre IA pour analyser le PLU"} */}
                    </div>
                    {/* DISCLAIMER */}
                    <div className={`app__ai_disclaimer_container ${isDisclaimer ? "app__ai_disclaimer_container_visble" : ""}`}>
                        <div style={{ height: '10px' }}></div>
                        <div className="app__ai_disclaimer_text">Notre IA analyse les documents disponibles sur le Géoportail de l'Urbanisme.<br />Sur cette base, elle préremplit des règles d'urbanisme dans notre outil.<br />Une vérification de votre part reste nécéssaire.</div>
                        <div className="app__ai_disclaimer_rep_container">
                            <div className="app__ai_disclaimer_rep_item" onClick={handleDisclaimerClick}>J'ai compris, lancer l'analyse</div>
                        </div>
                    </div>
                    {/* EXISTING RULES */}
                    <div className={`app__ai_disclaimer_container ${isAskingRules ? "app__ai_disclaimer_container_visble" : ""}`}>
                        <div style={{ height: '10px' }}></div>
                        <div className="app__ai_disclaimer_text">Des règles PLU existent déja.<br />Souhaitez-vous supprimer les règles existantes avant de lancer l'analyse ?</div>
                        <div className="app__ai_disclaimer_rep_container">
                            <div className="app__ai_disclaimer_rep_item" onClick={handleRulesResetClick}>Supprimer les règles</div>
                            <div className="app__ai_disclaimer_rep_item" onClick={handleRulesKeepClick}>Conserver les règles</div>
                        </div>
                    </div>
                    {/* ERROR */}
                    <div className={`app__ai_disclaimer_container ${isError ? "app__ai_disclaimer_container_visble" : ""}`}>
                        <div style={{ height: '10px' }}></div>
                        <div className="app__ai_disclaimer_text_error">{errorMessage}</div>
                        {/* <div className="app__ai_disclaimer_rep_container">
                            <div className="app__ai_disclaimer_rep_item" onClick={handleRulesResetClick}>Supprimer les règles</div>
                            <div className="app__ai_disclaimer_rep_item" onClick={handleRulesKeepClick}>Conserver les règles</div>
                        </div> */}
                    </div>
                    {/* AI STEPS */}
                    <div className={`app__ai_disclaimer_container ${AIstep > 0 ? "app__ai_disclaimer_container_visble_large" : ""}`}>
                        <div style={{ height: '10px' }}></div>
                        {/* <div className="app__ai_disclaimer_text">Etape 1 : Identification du règlement littéral</div> */}
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step1_status === "loading" ? "app__ai_step_container_loading" : ""} ${step1_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 1 : Identification des documents d'urbanisme principaux
                            </div>
                            <div className={`app__ai_step_description_none ${step1_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step1_description}</div>
                            <div className={`app__ai_step_status_link ${step1_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step2_status === "loading" ? "app__ai_step_container_loading" : ""} ${step2_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 2 : Compréhension de la structure des documents
                            </div>
                            <div className={`app__ai_step_description_none ${step2_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step2_description}</div>
                            <div className={`app__ai_step_status_link ${step2_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step3_status === "loading" ? "app__ai_step_container_loading" : ""} ${step3_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 3 : Analyse et création des règles communes à toutes les zones
                            </div>
                            <div className={`app__ai_step_description_none ${step3_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step3_description}</div>
                            <div className={`app__ai_step_status_link ${step3_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step4_status === "loading" ? "app__ai_step_container_loading" : ""} ${step4_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 4 : Analyse et création des règles spécifiques à la zone {capacity?.rules?.gpu_data?.zoneUrba[0]?.properties?.libelle || "PLU principale"}
                            </div>
                            <div className={`app__ai_step_description_none ${step4_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step4_description}</div>
                            <div className={`app__ai_step_status_link ${step4_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div>
                        </div>
                        <div className="app__ai_step_main_container">
                            <div className={`app__ai_step_container_none ${step5_status === "loading" ? "app__ai_step_container_loading" : ""} ${step5_status === "done" ? "app__ai_step_container_done" : ""}`}>
                                <div className="app__ai_step_status"><img src={ico_check} /></div>
                                Etape 5 : Analyse et création des règles spécifiques {capacity?.rules?.gpu_data?.zoneUrba2.length > 1 ? "aux zones PLU secondaires" : "à la zone PLU secondaire"}
                            </div>
                            <div className={`app__ai_step_description_none ${step5_description !== "" ? "app__ai_step_description_loding_done" : ""}`}>{step5_description}</div>
                            {/* <div className={`app__ai_step_status_link ${step5_status === "done" ? "app__ai_step_status_link_done" : ""}`}></div> */}
                        </div>
                    </div>
                    {/* AI CONCLUSION */}
                    <div className={`app__ai_disclaimer_container ${isEnding ? "app__ai_disclaimer_container_visble" : ""}`}>
                        <div style={{ height: '10px' }}></div>
                        <div className="app__ai_disclaimer_text">Notre IA a analysé {nbDocs > 1 ? (nbDocs + " documents") : "1 document"} d'urbanisme.<br />Suite à cette analyse,{nbRulesets_total > 1 ? (" " + nbRulesets_total + " ensembles de règles et ") : nbRulesets_total === 1 ? " 1 ensemble de règles et " : ""}{nbRules_total > 1 ? (nbRules_total + " règles ") : nbRules_total === 1 ? "1 règle " : ""}ont été créés.</div>
                        <div className="app__ai_disclaimer_rep_container">
                            <div className="app__ai_disclaimer_rep_item" onClick={handleEndValidateClick}>Valider</div>
                            <div className="app__ai_disclaimer_rep_item" onClick={handleEndResetClick}>Annuler et récupérer les anciennes règles</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="app__sectiondata_widget_spacer_20"></div>
        </div>
    );
};

export default AIpluFake;